import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button, LayerBottom, InputX } from 'components'
import styles from './index.module.css'

const SchoolMain = () => {

	const App = useApp()
	const [showOrgan, setShowOrgan] = useState(false)
	const [showLayer, setShowLayer] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const openOrgan = () => {
		setShowOrgan(true)
	}

	const closeOrgan = () => {
		setShowOrgan(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className={styles["l-title"]}>궁금한 보육시설/학교를 검색해보세요.</div>
				<div className="flex-align_center mt_40">
					<div className={`${styles["select-area"]} ${styles.box}`} onClick={openOrgan}>
						<span>기관 선택</span>
						<i className="icon" />
					</div>
					<div className={`${styles["select-area"]} ${styles.box} ml_10`} onClick={openLayer}>
						<span>지역 선택</span>
						<i className="icon" />
					</div>
				</div>
				<div className="form-group search-bar mt_30">
					<InputX type="text" placeholder="보육 및 교육 기관명을 입력해보세요." id="" />
					<i className="icon icon_search" />
				</div>

				<div className={`${styles["company-guide-box"]} center-cont mt_50`}>
					<h3 className="intro-tit">어린이집부터 초・중・고등학교까지<br />간단하게 조회해요!</h3>
					<span className="guide-title mt_20">보육기관 및 교육기관의 기본정보부터<br />학생 수, 교직원 구성 및 시설정보까지!</span>
					<i className="icon icon_other_search mt_50" style={{ width: "13rem", height: "11rem" }} />
				</div>
			</div>

			<OrganLayer show={showOrgan} closeLayer={closeOrgan} />
			<SelectLayer show={showLayer} closeLayer={closeLayer} />
		</div>
	)
}

const OrganLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="기관 선택" show={show} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<ul className="opt-menu">
				<li className="active">어린이집</li>
				<li>유치원</li>
				<li className="active">초등학교</li>
				<li>중학교</li>
				<li>고등학교</li>
			</ul>
		</LayerBottom>
	)
}

const SelectLayer = ({ show, closeLayer }) => {

	const [menuOpen, setMenuOpen] = useState(0)

	return (
		<LayerBottom title="지역 선택" show={show} closeLayer={closeLayer} closeButton={false} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<ul className={`${styles["area-list"]} accordion-list`}>
				<li className={menuOpen === 0 ? "active" : ""} onClick={() => setMenuOpen(0)}>
					<div className="flex-justify_between align_center">
						<p className="bold">서울</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">강남구</li>
							<li>강동구</li>
							<li>강부구</li>
							<li>강서구</li>
							<li>관악구</li>
							<li>광진구</li>
							<li>구로구</li>
							<li>금천구</li>
							<li>노원구</li>
							<li>도봉구</li>
							<li>동대문구</li>
							<li>동작구</li>
							<li>마포구</li>
							<li>서대문구</li>
							<li>서초구</li>
							<li>성동구</li>
							<li>성북구</li>
							<li>송파구</li>
							<li>양천구</li>
							<li>영등포구</li>
							<li>용산구</li>
							<li>은평구</li>
							<li>종로구</li>
							<li>중구</li>
							<li>중랑구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 1 ? "active" : ""} onClick={() => setMenuOpen(1)}>
					<div className="flex-justify_between align_center">
						<p className="bold">인천</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">중구</li>
							<li>동구</li>
							<li>미추홀구</li>
							<li>연수구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 2 ? "active" : ""} onClick={() => setMenuOpen(2)}>
					<div className="flex-justify_between align_center">
						<p className="bold">대전</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">대덕구</li>
							<li>서구</li>
						</ul>
					</div>
				</li>
			</ul>
		</LayerBottom>
	)
}

export default SchoolMain